import React, { useState, useEffect } from 'react';
import styles from '@/pages/camp/components/css/campCSS.less';
import { useRequest } from 'umi';
import { pageScoreLog } from '@/utils/requests/camp/requests_admin';
import { ScoreLogVO } from '@/types/camp/admin/studentType';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import useScrollHeight from '@/hooks/useScrollHeight';

interface Props {
  batchId: string;
  uid: number;
}
const ScoreLog: React.FC<Props> = ({ batchId, uid }) => {
  const [data, setData] = useState<ScoreLogVO[]>([]);
  const [loading, setLoading] = useState(true);
  const scrollHeight = useScrollHeight(360);
  const [current, setCurrent] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(0);

  // 获取接口
  const { run: pageScoreLogRequest } = useRequest(
    () => {
      let params = {
        uid: uid,
        current: current,
        size: size,
      };
      return pageScoreLog(batchId, params);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setData(res.records);
        setSize(res.size);
        setTotal(res.total);
        setCurrent(res.current);
        setLoading(false);
      },
    },
  );
  useEffect(() => {
    pageScoreLogRequest();
  }, []);
  useEffect(() => {
    pageScoreLogRequest();
  }, [current]);

  const columns: ColumnsType<ScoreLogVO> = [
    {
      title: '行为',
      dataIndex: 'nodeName',
      key: 'nodeName',
      width: '60%',
      render: (value, record) => {
        return (
          <div>
            <span style={{ paddingRight: 6 }}>{value}</span>
            <span>{record?.actionName}</span>
          </div>
        );
      },
    },
    {
      title: '变动学分',
      dataIndex: 'changeScore',
      key: 'changeScore',
      render: (value) => {
        return value <= 0 ? <span>{value}</span> : <span>+{value}</span>;
      },
    },
    {
      title: '变动后总学分',
      dataIndex: 'changeTotalScore',
      key: 'changeTotalScore',
    },
    {
      title: '时间',
      dataIndex: 'createdTime',
      key: 'createdTime',
      render: (value: any) => (value ? `${dayjs(value).format('YYYY-MM-DD HH:mm')}` : '--'),
    },
  ];
  return (
    <div>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          total: total,
          showTotal: (total, range) => `共 ${total} 条数据`,
          pageSize: size,
          current: current,
          hideOnSinglePage: true,
          showQuickJumper: true,
        }}
        onChange={(pagination) => {
          pagination.current && setCurrent(pagination.current);
          pagination.pageSize && setSize(pagination.pageSize);
        }}
        className={styles.study_log_table}
        scroll={{ y: scrollHeight }}
      />
    </div>
  );
};
export default ScoreLog;
